import { REMARKS_MAX_LENGTH } from '@src/config/ph/constant';
import React from 'react';

interface AgentRemarksBoxProps {
    value?: string;
    onChange?: (value: string) => void;
    maxLength?: number;
    label?: string;
    readOnly?: boolean;
    className?: string;
    rows?: number;
}

const AgentRemarksBox: React.FC<AgentRemarksBoxProps> = ({
    value = '',
    onChange,
    maxLength = REMARKS_MAX_LENGTH,
    label = 'Remarks',
    readOnly = false,
    className = '',
    rows = 4,
}) => {
    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        onChange?.(event.target.value.slice(0, maxLength));
    };

    return (
        <fieldset className={`remarksTxt ${className}`}>
            <div className="material">
                <textarea
                    rows={rows}
                    placeholder=" "
                    className="form-input textarea-height"
                    value={value}
                    onChange={handleChange}
                    maxLength={maxLength}
                    disabled={readOnly}
                    readOnly={readOnly}
                />
                <label data-label={label} className="form-label"></label>
            </div>
            {!readOnly && (
                <small className="char-limit">
                    {value.length}/{maxLength}
                </small>
            )}
        </fieldset>
    );
};

export default AgentRemarksBox;
